import Header from './header/Header';
import Footer from './footer/Footer';
import { Desktop } from '../helpers/MediaQueries';

const Layout = ({ children, route, location, offsetDesktopHeader = false }) => (
	<div className="inner-container">
		<Header {...{ route, location}} dark />
		<div id="page-wrap">
			<main className="min-content-height">
				{offsetDesktopHeader
					? <Desktop><div className={'desktop-header-offset'} /></Desktop>
					: null
				}
				{children}
			</main>
			<Footer />
		</div>
	</div>
);


export default Layout;


// WEBPACK FOOTER //
// ./components/Layout.js